import { clone as _clone, reject as _reject } from 'lodash';
import {
    CART_ADD_ITEM,
    CART_REMOVE_ITEM
} from '../constants/cart.js';

export const initialState = [];

export function cartReducer( state = initialState, action ) {

    switch ( action.type ) {

        case CART_ADD_ITEM:
            let cartItems = _clone( state );
            cartItems.push( action.item );
            return cartItems;

        case CART_REMOVE_ITEM:
            const cartWithItemRemoved =_reject( state, { uuid: action.itemHashID } );
            return cartWithItemRemoved;

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/cart.js